module.exports = ".textFillUpWitOptionQuestion {\n  height: 100%;\n  width: 100%;\n  color: rgb(128, 127, 131);\n  overflow: hidden;\n}\n\n.textFillUpWitOptionQuestionHeaderCon {\n  border-bottom: 1px solid lightgray;\n  background-color: rgb(219, 218, 221);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/question/fillupwithoption/fillupwithoption.component.css
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/question/fillupwithoption/fillupwithoption.component.css
// module chunks = main